import Button from "@app/components/button";
import GradientContainer from "@app/components/gradient/gradient-container";
import TextGradient from "@app/components/gradient/gradient-text";
import Image from "next/image";
import { useState } from "react";

const DesktopRetailGrocery = ({ inView }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="pb-72">
      <div className="flex justify-end">
        <div className="hidden xl:block">
          <Image
            src="/images/industries/retail-grocery2.png"
            alt="retail"
            className="rounded-3xl"
            width={760}
            height={512}
          />
        </div>
        <div className="xl:hidden">
          <Image
            src="/images/industries/retail-grocery2.png"
            alt="retail"
            className="rounded-3xl"
            width={660}
            height={442}
          />
        </div>
      </div>
      <div
        className={`shadow-lg-light absolute bg-opacity-90 -mt-[600px] bg-light blur-content 
            w-[60%] xl:w-[42%] 2xl:w-[55%] rounded-2xl p-6`}
        style={{
          visibility: inView ? "visible" : "hidden",
          transform: inView ? "translateX(0%)" : "translateX(-10%)",
          transition: "transform 500ms ease-in",
          // opacity: inView2 ? 0.9 : 0,
        }}>
        <div
          className={`flex flex-col ml-2 space-y-5 
          ${
            isExpanded
              ? "h-[510px] xl:h-[550px] xl-2:!h-[530px] 2xl:!h-[500px]"
              : "h-[370px] xl:h-[390px] xl-2:!h-[390px] 2xl:!h-[370px]"
          }
           transition-[height] ease-out duration-500 `}>
          <TextGradient>
            <p className="h2">01</p>
          </TextGradient>
          <p className="h4 xl:h3 text-background-primary-dark">
            Retail & grocery
          </p>
          <div>
            <GradientContainer overrideClassName="w-[40%] h-2" />
          </div>
          <div className="text-text-color-mid-em-light space-y-5">
            <p>SimpleWaste represents all sectors of the retail industry.</p>
            <p>
              Our unique service and technology platform is ideal for retail,
              storefronts, grocery, and convenience stores! Your various waste
              and recycling profiles are seamlessly managed through our
              technology portal.
            </p>
            {isExpanded && (
              <div className="space-y-5">
                <p>
                  Unlock ease-of-use functionality when it comes to
                  administration, procurement, and ongoing operations support.
                </p>
                <p>
                  Find the best pricing options for your represented regions
                  through our automated RFP Optimization Tool.
                </p>
              </div>
            )}
          </div>
          <div className="flex h-full items-end">
            <div>
              <Button onClick={() => setIsExpanded(!isExpanded)}>
                {isExpanded ? "Read less" : "Read more"}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DesktopRetailGrocery;
